export type FinalReviewVisualStatus = "pending" | "in_progress" | "completed" | "blocked";

export interface TaskPlanPresentation {
  completed: number;
  total: number;
  finalReviewStatus: FinalReviewVisualStatus;
}

export function taskPlanPresentation(input: {
  completed: number;
  total: number;
  active: boolean;
  failed: boolean;
}): TaskPlanPresentation {
  const planComplete = input.completed === input.total;
  const finalReviewStatus: FinalReviewVisualStatus = !planComplete
    ? "pending"
    : input.active
      ? "in_progress"
      : input.failed
        ? "blocked"
        : "completed";

  return {
    completed: input.completed + (finalReviewStatus === "completed" ? 1 : 0),
    total: input.total + 1,
    finalReviewStatus,
  };
}
